import graphql from "babel-plugin-relay/macro";
import { format, isAfter, isValid, max, min, parse } from "date-fns";
import { useFragment } from "react-relay";

import { useDepartmentGolfFacilitiesStartEndTime_department$key } from "./__generated__/useDepartmentGolfFacilitiesStartEndTime_department.graphql";

export const useDepartmentGolfFacilitiesStartEndTime = (
  departmentRef: useDepartmentGolfFacilitiesStartEndTime_department$key | null
) => {
  const department = useFragment(
    useDepartmentGolfFacilitiesStartEndTimeFragmentString,
    departmentRef
  );

  const golfFacilities = department?.facilities?.edges?.flatMap((e) =>
    e?.node?.type === "GOLF_COURSE" ? [e.node] : []
  );

  const facilityTimeRanges =
    golfFacilities?.flatMap((facility) => {
      const startTime = facility?.startEndTime?.startTime;
      const endTime = facility?.startEndTime?.endTime;

      return startTime && endTime
        ? [
            {
              startTime: parse(startTime, "HH:mm:ss", new Date()),
              endTime: parse(endTime, "HH:mm:ss", new Date()),
            },
          ]
        : [];
    }) || [];

  const startTimes = facilityTimeRanges.map(({ startTime }) => startTime);
  const endTimes = facilityTimeRanges.map(({ endTime }) => endTime);
  const overnightEndTimes = facilityTimeRanges
    .filter(({ startTime, endTime }) => isAfter(startTime, endTime))
    .map(({ endTime }) => endTime);

  const startTime = min(startTimes);
  const endTime = max(
    overnightEndTimes.length > 0 ? overnightEndTimes : endTimes
  );

  return {
    startTime: isValid(startTime) ? format(startTime, "HH:mm:ss") : undefined,
    endTime: isValid(endTime) ? format(endTime, "HH:mm:ss") : undefined,
  };
};

const useDepartmentGolfFacilitiesStartEndTimeFragmentString = graphql`
  fragment useDepartmentGolfFacilitiesStartEndTime_department on Department {
    facilities {
      edges {
        node {
          type
          startEndTime {
            startTime
            endTime
          }
        }
      }
    }
  }
`;
